// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/images/dashboard_background_2.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;

    position: fixed;
    top: var(--header-height);
    left: 0;
    width: 100%;
    height: 100%;
    padding: 20px 40px;
}

.enrolment-tile {
    width: 90%;
    max-width: 700px;
    align-items: center;
    padding: 1rem;
    border: 1px solid #ccc;
    position: relative;
    padding-right: 10px;
    margin-bottom: 10px;
    background-color: #f5f5f5;
    border-radius: 8px;
    margin-left: auto;
    margin-right: auto;
}
.enrolment-tile .beneficiary-name {
    font-size: 1.1em;

}
.enrolment-tile .date-updated {
    color: #121212;
    font-size: 0.9em;
    margin: 5px;
}
.enrolment-tile .action-buttons {
    position: absolute;
    top: 20px;
    right: 15px;
}
.enrolment-tile .edit-button a, .enrolment-tile .clickable {
    color: var(--primary-color);
    cursor: pointer;
    text-decoration: none;
}
.enrolment-tile .edit-button a:hover, .enrolment-tile .clickable:hover {
    color: var(--primary-color-dark);

}

.enrolments-list .enrollment-progress-stepper {
    margin-top: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/ManageEnrolments/ManageEnrolments.css"],"names":[],"mappings":"AAAA;IACI,yDAAsE;IACtE,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;IAC3B,4BAA4B;;IAE5B,eAAe;IACf,yBAAyB;IACzB,OAAO;IACP,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,gBAAgB;;AAEpB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;AACA;IACI,2BAA2B;IAC3B,eAAe;IACf,qBAAqB;AACzB;AACA;IACI,gCAAgC;;AAEpC;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".dashboard-container {\n    background-image: url(../../public/images/dashboard_background_2.webp);\n    background-size: cover;\n    background-attachment: fixed;\n    background-position: center;\n    background-repeat: no-repeat;\n\n    position: fixed;\n    top: var(--header-height);\n    left: 0;\n    width: 100%;\n    height: 100%;\n    padding: 20px 40px;\n}\n\n.enrolment-tile {\n    width: 90%;\n    max-width: 700px;\n    align-items: center;\n    padding: 1rem;\n    border: 1px solid #ccc;\n    position: relative;\n    padding-right: 10px;\n    margin-bottom: 10px;\n    background-color: #f5f5f5;\n    border-radius: 8px;\n    margin-left: auto;\n    margin-right: auto;\n}\n.enrolment-tile .beneficiary-name {\n    font-size: 1.1em;\n\n}\n.enrolment-tile .date-updated {\n    color: #121212;\n    font-size: 0.9em;\n    margin: 5px;\n}\n.enrolment-tile .action-buttons {\n    position: absolute;\n    top: 20px;\n    right: 15px;\n}\n.enrolment-tile .edit-button a, .enrolment-tile .clickable {\n    color: var(--primary-color);\n    cursor: pointer;\n    text-decoration: none;\n}\n.enrolment-tile .edit-button a:hover, .enrolment-tile .clickable:hover {\n    color: var(--primary-color-dark);\n\n}\n\n.enrolments-list .enrollment-progress-stepper {\n    margin-top: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
